import { render, staticRenderFns } from "./Firmenangaben.vue?vue&type=template&id=55e91f9a"
import script from "./Firmenangaben.vue?vue&type=script&lang=js"
export * from "./Firmenangaben.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports